export enum CommentType {
  PRIVATE = 'Private',
  PUBLIC = 'Public',
}
